import { render, staticRenderFns } from "./SingleCampaignMail.vue?vue&type=template&id=6736f263&scoped=true&"
import script from "./SingleCampaignMail.vue?vue&type=script&lang=js&"
export * from "./SingleCampaignMail.vue?vue&type=script&lang=js&"
import style0 from "./SingleCampaignMail.vue?vue&type=style&index=0&id=6736f263&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6736f263",
  null
  
)

export default component.exports